import { ROUTE_NAMES } from "@root/constants";
import SuperAdminLayout from "@root/layouts/SuperAdminLayout";
import { Login } from "@root/pages";
import { SuperAdminDashboard } from "@root/pages/dashboard/Super-admin-dashboard/SuperAdminDashboard";
import { createBrowserRouter, Navigate } from "react-router-dom";
import SubscriberManagement from "@root/pages/kpec-admin/subscriber-management/subscriber-management";
import SubscriberCourses from "@root/pages/kpec-admin/subscriber-management/subscriber-courses";
import SubscriberMembers from "@root/pages/kpec-admin/subscriber-management/subscriber-members";
import { AdminContextProvider } from "@root/context/use-admin-context";
import FAQnQAPage from "@root/pages/faq/faqnQA";
import { MyProfile } from "@root/pages/profilesection-journalist/myprofile";
import { UpdateProfile } from "@root/pages/profilesection-journalist/updateprofile/updateprofile";

export const superAdminRoutes = createBrowserRouter([
  {
    path: "/super-admin",
    element: (
      <AdminContextProvider>
        <SuperAdminLayout />
      </AdminContextProvider>
    ),
    children: [
      {
        path: "",
        element: <Navigate to={ROUTE_NAMES.SUPER_ADMIN_DASHBOARD} />,
      },
      {
        path: ROUTE_NAMES.SUPER_ADMIN_DASHBOARD,
        element: <SuperAdminDashboard />,
      },
      // {
      //   path: ROUTE_NAMES.USER_SUBSCRIPTION,
      //   element: <SubscriberManagement />,
      // },
      {
        path: ROUTE_NAMES.SUPER_ADMIN_PROFILE,
        element: <MyProfile />,
      },
      {
        path: ROUTE_NAMES.SUPER_ADMIN_UPDATE_PROFILE,
        element: <UpdateProfile />,
      },
      {
        path: ROUTE_NAMES.SUBSCRIBER_COURSE,
        element: <SubscriberCourses />,
      },
      {
        path: ROUTE_NAMES.SUBSCRIBER_MEMBERS,
        element: <SubscriberMembers />,
      },
    ],
  },
  {
    path: "*",
    element: <Navigate to={ROUTE_NAMES.SUPER_ADMIN_DASHBOARD} />,
  },
]);
